export default __webpack_public_path__ + "static/kubernetes_logo-f91022b1deed067a9393dd3c42381ab7.svg";